import Paroller from 'paroller.js';

export default class FrontPage {
    
    constructor()
    {
        FrontPage.engine_rando();
        FrontPage.animation();
        FrontPage.agenda();
    }
    
    static engine_rando()
    {
        const type   = "[data-trigger='wpiris-engine-rando-type']";
        const select = "[data-id='wpiris-engine-rando-form-select']";
        const form   = "[data-id='wpiris-engine-rando-form']";
        const button = "[data-trigger='wpiris-engine-rando-submit']";
        
        $( document ).on( 'click', button, function ( e ) {
            e.preventDefault();
            let url  = $( form ).attr( 'action' );
            let data = $( form ).serializeArray();
            
            $( select ).each( function ( i ) {
                if ( $( this ).val() == 0 ) {
                    let id = $( this ).attr( 'id' );
                    $( this ).attr( 'name', id );
                }
            } );
            
            $( form ).trigger( 'submit' );
            
        } );
        
        $( document ).on( 'click', type, function ( e ) {
            if ( $( this ).prop( "checked", true ) ) {
                let type = $( this ).attr( 'value' );
                $( select ).each( function ( i ) {
                    $( this ).find( 'option:selected' ).removeAttr( 'selected' );
                    $( this ).find( 'option:first' ).attr( 'selected' );
                } );
                FrontPage.engine_ajax_reload();
            }
        } );
        
        $( document ).on( 'change', select, function ( e ) {
            FrontPage.engine_ajax_reload();
        } );
        
        $( button ).bind( 'click', function ( e ) {
            if ( $( 'input[name="wpet_search[types][]"]:checked' ).length <= 0 ) {
                e.preventDefault();
                $( button ).popover( 'show' );
            }
        } );
    }
    
    static engine_ajax_reload( type, action )
    {
        const form        = "[data-id='wpiris-engine-rando-form']";
        const form_select = "[data-id='wpiris-engine-rando-form-select']";
        let data          = $( form ).serializeArray();
        
        let loader = '[data-id="wpiris-rando-loader"]';
        $( loader ).show();
        
        $( data ).each( function ( index, value ) {
            if ( value.value == 0 ) {
                data.splice( index, 1 );
            }
        } );
        
        data.push( {
                       name: 'action',
                       value: 'rando_engine'
                   } );
        
        $.ajax( {
                    url: Theme.ajaxURL,
                    type: 'POST',
                    dataType: 'JSON',
                    data: data,
                    success: function ( response ) {
                        $( loader ).hide();
                        $( 'select#commune option:not(.default)' ).remove();
                        $( 'select#difficulte option:not(.default)' ).remove();
                        $( 'select#themes option:not(.default)' ).remove();
                
                        if ( typeof response.commune !== "undefined" ) {
                            $( 'select#commune' ).parent().show();
                            let option = '';
                            $.each( response.commune, function ( key, value ) {
                                option += '<option value="' + value.value + '" ' + value.selected + '>' + value.label + '</option>';
                            } );
                    
                            if ( option != '' ) {
                                $( 'select#commune option.default' ).after( option );
                            }
                        } else {
                            $( 'select#commune' ).parent().hide();
                        }
                
                        if ( typeof response.difficulte !== "undefined" ) {
                            $( 'select#difficulte' ).parent().show();
                            let option = '';
                            $.each( response.difficulte, function ( key, value ) {
                                option += '<option value="' + value.value + '" ' + value.selected + '>' + value.label + '</option>';
                            } );
                    
                            if ( option != '' ) {
                                $( 'select#difficulte option.default' ).after( option );
                            }
                        } else {
                            $( 'select#difficulte' ).parent().hide();
                        }
                
                        if ( typeof response.themes !== "undefined" ) {
                            $( 'select#themes' ).parent().show();
                            let option = '';
                            $.each( response.themes, function ( key, value ) {
                                option += '<option value="' + value.value + '" ' + value.selected + '>' + value.label + '</option>';
                            } );
                    
                            if ( option != '' ) {
                                $( 'select#themes option.default' ).after( option );
                            }
                        } else {
                            $( 'select#themes' ).parent().hide();
                        }
                
                        if ( typeof response[ 'types' ] !== "undefined" ) {
                            $( '[data-trigger="wpiris-engine-rando-type"]' ).hide();
                            $.each( response[ 'types' ], function ( key, value ) {
                                $( '[value="' + value.value + '"]' ).show();
                            } );
                        }
                    }
                } );
    }
    
    static animation()
    {
        if ( window.matchMedia( "(min-width: 1000px)" ).matches ) {
            $( '[data-paroller]' ).paroller();
        }
    }
    
    static agenda()
    {
        $( '#strateAgenda .strateButtonItem--rel a' ).on( 'click', function () {
            let rel = $( this ).attr( 'rel' );
            $( '#datedebutlisting_18' ).val( rel );
            $( '#agendaHomeForm' ).submit();
            return false;
        } );
        
    }
}
